import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({ gfm: true, breaks: true });

/** Farben für Text: {rot:Text} – dieselben wie in den Kommentaren (kommentartext.ts FARBEN). Hex-Werte für Word. */
export const MD_FARBEN = { rot: 'C0392B', orange: 'B85C00', gruen: '23774A', blau: '0074A8', violett: '7D3C98', grau: '6B7780' };
const FARBE_AUF = new RegExp(`\\{(${Object.keys(MD_FARBEN).join('|')}):`);
const FARBE_START = new RegExp('^' + FARBE_AUF.source);

/** Schließende Klammer zu einer {farbe:-Klammer ab Stelle `ab` (geschachtelte zählen mit); -1 = keine. */
function klammerEnde(s, ab) {
  let tiefe = 0;
  for (let k = ab; k < s.length; k++) {
    if (s[k] === '{') tiefe++;
    else if (s[k] === '}' && tiefe-- === 0) return k;
  }
  return -1;
}

// Markdown-Erweiterung: {farbe:Text} färbt Text innerhalb eines Absatzes; darin gilt weiter Markdown (**fett** usw.)
marked.use({
  extensions: [{
    name: 'farbe', level: 'inline',
    start(src) { const m = FARBE_AUF.exec(src); return m ? m.index : undefined; },
    tokenizer(src) {
      const m = FARBE_START.exec(src);
      if (!m) return undefined;
      const zu = klammerEnde(src, m[0].length);
      if (zu < 0 || src.slice(m[0].length, zu).includes('\n\n')) return undefined;
      const innen = src.slice(m[0].length, zu);
      return { type: 'farbe', raw: src.slice(0, zu + 1), farbe: m[1], text: innen, tokens: this.lexer.inlineTokens(innen) };
    },
    renderer(token) { return `<span class="kt-${token.farbe}">${this.parser.parseInline(token.tokens)}</span>`; },
  }],
});

/** Markdown → bereinigtes HTML. */
export function mdHtml(text) {
  if (!text) return '';
  return DOMPurify.sanitize(marked.parse(String(text)));
}

export function mdTokens(text) {
  return marked.lexer(String(text || ''));
}

/**
 * Markdown als Klartext für Ausgaben ohne Formatierung (z. B. Tabellenzellen im Word-Export): Überschriften-, Zitat- und
 * Hervorhebungs- und Farbzeichen fallen weg, Aufzählungen beginnen mit „•“, Links werden zu „Text (Adresse)“, Tabellen zu „a | b“.
 * Zeilen und Absätze bleiben. Gleiche Regeln wie Markdown.Klartext in api/Projects.Kern/Markdown.cs.
 */
const FARBE_OHNE = new RegExp(`\\{(${Object.keys(MD_FARBEN).join('|')}):([^{}]*)\\}`, 'g');

export function mdKlartext(text) {
  if (!text || !String(text).trim()) return '';
  return String(text).replace(/\r\n?/g, '\n')
    .replace(/^\s*(```|~~~).*$/gm, '')
    .replace(/^[ \t]*\|?[ \t]*:?-{2,}:?[ \t]*(\|[ \t]*:?-{2,}:?[ \t]*)*\|?[ \t]*$\n?/gm, '')
    .replace(/^\s*([-*_])(\s*\1){2,}\s*$/gm, '')
    .replace(/^(\s*)#{1,6}\s+/gm, '$1')
    .replace(/^(\s*)(>\s?)+/gm, '$1')
    .replace(/^(\s*)[-*+]\s+(\[[ xX]\]\s+)?/gm, '$1• ')
    .replace(/^\s*\|(.*)\|\s*$/gm, (_, z) => z.split('|').map((x) => x.trim()).join(' | '))
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
    .replace(/\[([^\]]+)\]\(\s*([^)\s]+)[^)]*\)/g, (_, t, u) => (t === u ? u : `${t} (${u})`))
    .replace(/(\*\*|__)(?=\S)(.+?)(?<=\S)\1/g, '$2')
    .replace(/(?<![\w*])\*(?=\S)([^*\n]+?)(?<=\S)\*(?![\w*])/g, '$1')
    .replace(/(?<![\w_])_(?=\S)([^_\n]+?)(?<=\S)_(?![\w_])/g, '$1')
    .replace(/~~(?=\S)(.+?)(?<=\S)~~/g, '$1')
    .replace(/`([^`\n]+)`/g, '$1')
    .replace(FARBE_OHNE, '$2').replace(FARBE_OHNE, '$2').replace(FARBE_OHNE, '$2')
    .replace(/[ \t]+$/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
